import { render, staticRenderFns } from "./ItemIds.vue?vue&type=template&id=040e6fb8&scoped=true&"
import script from "./ItemIds.vue?vue&type=script&lang=js&"
export * from "./ItemIds.vue?vue&type=script&lang=js&"
import style0 from "./ItemIds.vue?vue&type=style&index=0&id=040e6fb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e6fb8",
  null
  
)

export default component.exports